import React from 'react';
import { StaticQuery, graphql } from 'gatsby';
import { FooterProps } from './Footer.types';
import { Footer as BaseFooter } from '@dls/web';
import styled from 'styled-components';
import { cookiePolicyPath } from '../../config/links';
import { translation as t } from '../../helpers/translation';

export const StyledFooterLink = styled.a`
  text-decoration: none;
`;

export const PureFooter = ({ data, baseUrl }: FooterProps) => {
  const { footer: footerData } = data;

  const footerText = (
    <div>
      {t('USAGE_OF_COOKIES')}
      <StyledFooterLink
        type="link"
        href={`${baseUrl}${cookiePolicyPath}`}
        target="_blank"
        rel="noopener noreferrer"
      >
        {t('COOKIES_READ')}
      </StyledFooterLink>
      {t('ABOUT_COOKIE_POLICY')}
    </div>
  );

  return (
    <BaseFooter
      baseUrl={baseUrl}
      copyrightText={footerData.copyrightText}
      links={footerData.links}
      footerText={footerText}
    />
  );
};

export const Footer = props => {
  return (
    <StaticQuery
      query={graphql`
        {
          footer {
            links: links {
              text
              link
            }
            copyrightText
          }
        }
      `}
      render={data => <PureFooter data={data} {...props} />}
    />
  );
};

export default Footer;
